var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalft20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.1167C22.732 29.1167 29 22.8487 29 15.1167C29 7.38471 22.732 1.1167 15 1.1167C7.26801 1.1167 1 7.38471 1 15.1167C1 22.8487 7.26801 29.1167 15 29.1167Z",
    fill: "white",
    stroke: "#612AFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.1167C17.9174 26.1167 20.7153 24.9578 22.7782 22.8949C24.8411 20.832 26 18.0341 26 15.1167C26 12.1993 24.8411 9.40143 22.7782 7.33853C20.7153 5.27563 17.9174 4.1167 15 4.1167L15 15.1167L15 26.1167Z",
    fill: "#612AFF",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66311 18.8782C5.43516 20.9998 6.84138 22.8326 8.69087 24.1275C10.5404 25.4225 12.7435 26.117 15.0013 26.1167L15 15.1167L4.66311 18.8782Z",
    fill: "#612AFF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalft20);
export default __webpack_public_path__ + "static/media/halft20.ced2cea5d0c9122807d29e222f8589d5.svg";
export { ForwardRef as ReactComponent };